// extracted by mini-css-extract-plugin
export var card = "_6x-0";
export var expandedCard = "_6x-2";
export var paginated = "_6x-1";